import { Injectable } from '@angular/core';
import { BaseEntityService } from '../../dashboard/classes/base-entity-service';

@Injectable()
export class FileService extends BaseEntityService {
  public endpoint = {root: 'files', many: 'file', search: 'files'};
  search(options) {
    const endpoint = this.endpoint.search || this.endpoint.many || this.endpoint.root.slice(0, this.endpoint.root.length - 1);
    return this.api.get(`${endpoint}`, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/file.service.ts